import { isNullOrEmpty } from '@/helpers/string';
import type { BaseEntityResponse } from '@/types/core';
import { parseISO } from 'date-fns';

class BaseEntityModel {
  createdAt: Date | null;
  uid: string;
  updatedAt: Date | null;

  constructor(model: Partial<BaseEntityResponse> = {}) {
    this.createdAt = model.created_at ? parseISO(model.created_at) : null;
    this.uid = model.uid ?? '';
    this.updatedAt = model.updated_at ? parseISO(model.updated_at) : null;
  }

  get isNew(): boolean {
    return isNullOrEmpty(this.uid);
  }
}

export default BaseEntityModel;
